/**
 * Links from vetina.eu to the public booking portal (weterynarz.vetina.eu).
 *
 * The portal is a separate application on its own subdomain, so it does not
 * inherit vetina.eu authority automatically. Google currently reports every
 * portal URL as "Crawled - currently not indexed" and, before this file
 * existed, vetina.eu did not link to the portal a single time. These links are
 * the cheapest available signal that the portal is part of the same product.
 *
 * Keep them plain `<a href>` (crawlable, no `rel="nofollow"`, no JS redirect).
 */
export const BOOKING_PORTAL_URL = "https://weterynarz.vetina.eu";

/** Cities in the first indexing wave, ordered by Search Console impressions. */
export const BOOKING_PORTAL_CITIES = [
  { label: "Wrocław", href: `${BOOKING_PORTAL_URL}/weterynarz/wroclaw` },
  { label: "Kraków", href: `${BOOKING_PORTAL_URL}/weterynarz/krakow` },
  { label: "Poznań", href: `${BOOKING_PORTAL_URL}/weterynarz/poznan` },
  { label: "Katowice", href: `${BOOKING_PORTAL_URL}/weterynarz/katowice` },
  { label: "Warszawa", href: `${BOOKING_PORTAL_URL}/weterynarz/warszawa` },
] as const;

export const BOOKING_PORTAL_GUIDE_URL = `${BOOKING_PORTAL_URL}/poradnik`;
